import { computed } from 'vue';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { useRoutingStore } from '@/helpers/composables/useStores';

export function useJWTVCampaign() {
	const { activeRoute } = useRoutingStore();

	const hasActiveJwtvCampaign = computed(() => {
		const jwtvCampaignParam = activeRoute.value?.query?.['utm_campaign']?.toString() || '';
		return !!jwtvCampaignParam?.toLowerCase().includes('jwtv');
	});

	function getPromotedOffersWithJwtv<T extends { package: { shortName: string } }>(
		promotedOffers: T[],
		title: TitleDetail
	): T[] {
		if (!hasActiveJwtvCampaign.value) {
			return promotedOffers;
		}

		const jwtvOffer = title.rent?.find(offer => offer.package.shortName === 'jwt');
		if (jwtvOffer) {
			return [jwtvOffer as unknown as T];
		}

		return promotedOffers;
	}

	return {
		hasActiveJwtvCampaign,
		getPromotedOffersWithJwtv,
	};
}
